<template>
  <div class='indexbox'>
    <nav-bar left-arrow :title="$t('理财')" />
    <div class="bodybox">
      <!-- <div class="imgs">
        <img :src="url" alt="">
      </div> -->
      <div class="item">
        <div class="top">
          <div class="top1">{{ info.name }}</div>
          <div class="top2">
            <div>{{ info.cycle }}{{ $t('天') }}</div>
          </div>
        </div>
        <div class="bottom">
          <div class="bottom1">
            <p>{{ $t('价格') }}</p>
            <p>{{ info.amount }}ACT</p>
          </div>
          <div class="bottom1">
            <p>{{ $t('收益率') }}</p>
            <p>{{ info.rate }}%</p>
          </div>
        </div>
        <div class="b">
          <van-progress :percentage="percentFun()" color="#ee0a24" track-color="#fff" />
        </div>
      </div>
      <div class="content">
        <div class="num">
          <text-span>数量</text-span>
          <van-stepper v-model="num" min="1" :max="max" integer input-width="80" disable-input />
        </div>
        <p>{{ $t('交易密码') }}</p>
        <van-field v-model="password" type="password" maxlength="6" :placeholder="$t('请输入交易密码')" clearable
          :border="false" />
        <van-button block color="linear-gradient(270deg, #FFD791 0%, #F4BB67 100%)" :loading="loading" @click="pay">{{
          $t('确定') }}</van-button>
      </div>
      <div class="tit" @click="router('/wodlicai')">
        <p>{{ $t('我的理财') }}</p>
        <van-icon name="arrow" color="#fff" size="14" />
      </div>

      <van-tabs v-model="active" sticky offset-top="46" background="#242424" title-active-color="#ceb082"
        color="#ceb082" @click="tabChange">
        <van-tab :title="$t(val.name)" v-for="val in toplist" :key="val.id">
          <template v-if="active == 0">
            <div-card bg='#242424' padding='3vw' margin="3vw 0 0 0" v-for="(item, index) in list" :key="index">
              <div class="head" @click="router(`licailog?id=${item.id}`)">
                <span>{{ item.created_at }}</span>
                <span>
                  {{ $t('理财中') }}
                  <van-icon name="arrow" color="#CEB082" size="14" />
                </span>
              </div>
              <van-divider style="margin:4vw 0" />
              <div-padding padding='0vw'>
                <div-flex>
                  <div>
                    <div-text color='#999999' size='3.5vw' center>{{ $t('已收益') }}</div-text>
                    <div-height height='1vw' />
                    <div-text color='#CEB082' size='4vw' center>{{ item.already_profit }}</div-text>
                  </div>
                  <div>
                    <div-text color='#999999' size='3.5vw' center>{{ $t('每日收益') }}</div-text>
                    <div-height height='1vw' />
                    <div-text color='#CEB082' size='4vw' center>{{ item.every_profit }}</div-text>
                  </div>
                  <div>
                    <div-text color='#999999' size='3.5vw' center>{{ $t('到期收益') }}</div-text>
                    <div-height height='1vw' />
                    <div-text color='#CEB082' size='4vw' center>{{ item.profit }}ACT</div-text>
                  </div>
                </div-flex>
                <p style="width: 100%;height: 10px;"></p>
                <div-flex>
                  <div>
                    <div-text color='#999999' size='3.5vw' center>{{ $t('周期') }}</div-text>
                    <div-height height='1vw' />
                    <div-text color='#CEB082' size='4vw' center>{{ item.cycle }}{{ $t('天') }}</div-text>
                  </div>
                  <div>
                    <div-text color='#999999' size='3.5vw' center>{{ $t('理财收益率') }}</div-text>
                    <div-height height='1vw' />
                    <div-text color='#CEB082' size='4vw' center>{{ item.rate }}%</div-text>
                  </div>
                  <div>
                    <div-text color='#999999' size='3.5vw' center>{{ $t('理财金额') }}</div-text>
                    <div-height height='1vw' />
                    <div-text color='#CEB082' size='4vw' center>{{ item.amount }}ACT</div-text>
                  </div>
                </div-flex>
              </div-padding>
            </div-card>
          </template>
          <template v-if="active == 1">
            <van-list v-model="lloading" :finished="lfinished" @load="onLoad" :finished-text="$t('没有更多了')"
              :immediate-check="false">
              <div-card bg='#242424' margin="3vw 0 0 0" padding='3vw' v-for="(item, index) in lists" :key="index">
                <div-flex>
                  <div-text color='#fff' size='4vw'>{{ item.remark }}</div-text>
                  <div-text color='#CEB082' size='4vw'>{{ item.amount }} USDT</div-text>
                </div-flex>
                <van-divider style="margin:3vw 0" />
                <div-text color='#999' size='3.5vw'>{{ $t('操作时间') }}：{{ item.created_at }}</div-text>
              </div-card>
            </van-list>
          </template>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        id: this.urlQuery().id,
        info: {},
        url: '',

        max: 1,
        password: '',
        num: '',
        loading: false,

        list: [],
        active: 0,
        toplist: [{ name: '理财记录', id: 0 }, { name: '理财收益', id: 1 }],
        page: 1,
        lists: [],
        lloading: false,
        lfinished: false,
      }
    },
    created() {
      this.getinfo()
      this.getlist()
    },
    mounted() { },
    methods: {
      getinfo() {
        this.$get({
          loading: true,
          url: `/api/v1/user/level/${this.id}`,
          success: (res) => {
            this.info = res.data
            this.url = this.info.img[0].url
            this.max = Number(this.info.stock) - Number(this.info.sales)
          },
          tip: () => { },
        })
      },
      pay() {
        if (!this.password) return this.$toast(this.$t("请输入交易密码"))
        if (this.loading == true) {
          return this.$toast(this.$t("请勿重复提交"))
        }
        this.loading = true
        this.$post({
          url: "/api/v1/user/financial",
          data: {
            level_id: this.id,
            trade_password: this.password,
            num: this.num,
          },
          success: (res) => {
            this.password = ""
            setTimeout(() => {
              this.loading = false
            }, 1500)
            this.$toast({
              message: this.$t("参与成功"),
              onClose: () => {
                this.$router.go(-1)
              }
            })
          },
          tip: () => {
            this.password = ""
            setTimeout(() => {
              this.loading = false
            }, 200)
          },
        })
      },
      percentFun() {
        if (this.info.stock && this.info.sales) {
          let num = Number(this.info.stock) - Number(this.info.sales)
          return Number(num / Number(this.info.stock) * 100).toFixed(2)
        }
        return 100
      },
      getlist() {
        this.$get({
          url: `/api/v1/user/financial?status=1`,
          success: (res) => {
            this.list = res.data.data
          },
          tip: () => { },
        })
      },
      tabChange(index) {
        if (index == 1) {
          this.page = 1
          this.lists = []
          this.lfinished = false
          this.onLoad()
        }
      },
      onLoad() {
        let page = this.page++
        this.$get({
          url: "/api/v1/user/income/balance_log",
          data: { page, },
          success: (res) => {
            if (!res.data || res.data.data.length == 0) {
              this.lfinished = true
            } else {
              var list = res.data.data
              if (page == 1) {
                this.lists = list
              } else {
                for (var i in list) {
                  this.lists.push(list[i])
                }
              }
            }
            this.lloading = false
          },
          tip: () => {
            this.lfinished = true
          },
        })
      }
    },
  }
</script>
<style lang='less' scoped>
  .bodybox {
    width: 100%;
    padding: 10px 15px;
    .imgs {
      width: 100%;
      height: 280px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 10px;
      background: #242424;
      border-radius: 6px;
      padding: 5px;
      box-sizing: border-box;
      img {
        width: 100%;
        height: 100%;
        border-radius: 5px;
        object-fit: contain;
      }
    }
    .item {
      width: 100%;
      background: #242424;
      border-radius: 6px;
      padding: 10px 15px;
      margin-bottom: 15px;
      .top {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        .top1 {
          font-size: 4vw;
          color: #fff;
          font-weight: 550;
        }
        .top2 {
          border: #ceb082 1px solid;
          border-radius: 1vw;
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 0vw 2vw;
          div {
            font-size: 3.5vw;
            color: #ceb082;
          }
        }
      }
      .bottom {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;
        padding: 15px 0;
        .bottom1 {
          min-width: 45%;
          p {
            font-size: 3.5vw;
            color: #999999;
            &:nth-child(2) {
              font-size: 4vw;
              color: #ceb082;
              font-weight: 550;
            }
          }
        }
      }
      .b {
        width: 100%;
        padding: 10px 0;
      }
    }
    .content {
      width: 100%;
      background: #242424;
      border-radius: 6px;
      padding: 10px 15px;
      margin-bottom: 30px;
      .num {
        width: 100%;
        padding: 10px 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        >span {
          font-size: 15px;
          font-weight: 550;
        }
        :deep(.van-stepper) {
          display: flex;
        }
      }
      >p {
        width: 100%;
        font-size: 15px;
        font-weight: 550;
        padding: 5px 0 10px;
      }
      /deep/.van-cell {
        background: #0f0f0f;
        border-radius: 6px;
        margin-bottom: 15px;
        padding: 3vw;
        .van-cell__title {
          width: 4em;
          color: #fff;
        }
        .van-field__control {
          color: #fff;
        }
      }
      .van-button {
        margin-top: 40px;
      }
    }
    .tit {
      width: 100%;
      padding: 5px 0 15px;
      font-size: 15px;
      font-weight: 550;
      color: #fff;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .head {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      span {
        &:nth-child(2) {
          color: #CEB082;
        }
      }
    }
  }
</style>